module.exports = __webpack_public_path__ + "static/media/Aptihealth-National-Recovery-Month-Celebrating-Self-Care-Blog.3d12bf79.jpg";